import React, { Fragment } from 'react';
import { Button, Form } from 'antd';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { FormattedMessage } from 'react-intl';
import AbstractMachine from './abstractMachine';

import userAPI from '../../../../API/user.service.api';
import {
  PASSWORD,
  START_LOGIN,
  SUGGESTION,
  CHECKING_EMAIL,
} from '../../../../constants/enter.user.constants';

export default class StartLogin extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = START_LOGIN;
    this._nextState = PASSWORD;

    this._changed = null;
  }

  onChange = (e) => {
    const val = e.target.value;
    const pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    if (pattern.test(val)) {
      this._goTo(null, this.asyncCheckingEmail, val);
    }
    this.clear();
    this._changed = setTimeout(() => {
      this.onSubmit();
    }, 6000);
  };

  clear = () => {
    if (this._changed) clearTimeout(this._changed);
  };

  asyncCheckingEmail = (dispatch, userEmail) => {
    userAPI.checkUserByEmail(userEmail).then((resp) => {
      const state = this.getState({ ...resp.response, userEmail }, true);
      if (state) {
        this.clear();
        dispatch(setStateUserEnter(state));
      }
    });
  };

  onSubmit = () => {
    this.clear();
    this._form
      .validateFields()
      .then((values) => {
        const { userEmail } = values;
        this._goTo(null, this.checkingEmail, userEmail);
      })
      .catch((err) => {
        const { userEmail } = err;
        if (userEmail) {
          this._goTo(null, this.setError, {
            ...userEmail.errors[0],
            name: this._name,
          });
        }
      });
  };

  setError = (dispatch, { message, name }) => {
    dispatch(setStateUserEnter({ name, error: message }));
  };

  getState = ({ exist = 0, islegalon = 0, userEmail }, isAsync = false) => {
    if (exist) {
      return {
        name: this._nextState,
        userEmail,
        isLegalOn: islegalon,
      };
    }
    if (isAsync) {
      return null;
    }
    return { name: SUGGESTION };
  };

  checkingEmail = (dispatch, userEmail) => {
    dispatch(setStateUserEnter({ name: CHECKING_EMAIL, userEmail }));
    userAPI.checkUserByEmail(userEmail).then(
      (resp) => {
        let state = {};
        if (resp.code === 200) {
          state = this.getState({ ...resp.response, userEmail });
        } else {
          state = {
            name: this._name,
            userEmail,
            error: resp.message,
          };
        }
        dispatch(setStateUserEnter(state));
      },
      (error) => {
        dispatch(setStateUserEnter({ error })); // need to contitune!!!
      }
    );
  };

  render(props) {
    return (
      <>
        {this.getMainInput(props, props.ref)}
        <Form.Item className="width100" style={{ marginBottom: '18px' }}>
          <Button
            type="primary"
            className="ant-btn-primary width100"
            onClick={this.onSubmit}
          >
            <span>
              <FormattedMessage id="Continue" defaultMessage="Continue" />
            </span>
          </Button>
        </Form.Item>
      </>
    );
  }
}
